import { useCallback } from 'react';

import { FormLabel, StyledFlex, Tag } from '@dreryk/react-components';

import { PatientGroup } from './fields/PatientGroupsAssignmentsMultiselect.types';

type PatientGroupsAssignmentsSelectedGroupViewProps = {
   selectedGroups: PatientGroup[];
   onClear: (group: PatientGroup) => void;
};

const EmptyLabel = (): JSX.Element => <span aria-hidden={'true'}>&nbsp;</span>;

export const PatientGroupsAssignmentsSelectedGroupView = (
   props: PatientGroupsAssignmentsSelectedGroupViewProps
): JSX.Element => {
   const { onClear } = props;
   const handleOnClear = useCallback((group: PatientGroup) => () => onClear(group), [onClear]);

   return (
      <StyledFlex direction={'column'} gap={8} alignItems={'flex-start'}>
         <FormLabel label={<EmptyLabel />} testId={'selectedPatientGroupsSpacer'} nowrap />
         <StyledFlex gap={8} flexWrap={'wrap'} alignItems={'flex-start'}>
            {props.selectedGroups.map((group) => (
               <Tag
                  onClear={handleOnClear(group)}
                  text={group.name}
                  key={group.id}
                  testId={group.id}
                  lightColor={group.primaryColor.asHexString()}
                  darkColor={group.darkModeColor?.asHexString()}
               />
            ))}
         </StyledFlex>
      </StyledFlex>
   );
};
